export enum RoutePath {
  Goals = '/goals',
  Offer = '/offer',
  YourGoal = '/your-goal',
  ExitSurvey = '/exit-survey',
  YourName = '/your-name',
  ConfirmYourCredentials = '/your-credentials',
  OutOfState = '/out-of-state',

  OfferAvailable = '/offer-available',

  CardInfo = '/card-info',

  ConfirmLoan = '/confirm-loan',
  DocuSignSignature = '/docu-sign-signature',
  SetupAccount = '/setup-account',
  VerificationSteps = '/verification-steps',
  VerifyingApplication = '/verifying-application',
  VerifyingKyc = '/verifying-kyc',
  Alloy = '/alloy',
  UploadIncomeVerification = '/upload-income-verification',
  VerifyIncome = '/verify-income',
  RepaymentMethod = '/repayment-method',
  OpenDDA = '/open-dda',
  SetupDeduction = '/setup-deduction',
  SetupViaPayroll = '/setup-via-payroll',
  WhatIsTheIssue = '/dda-issue',
  NotifyYourTeam = '/notify-your-team',
  VerifyPayrollDeduction = '/verify-payroll-deduction',
  PaystubsSignInGuide = '/paystubs-sign-in-guide',

  SelectDebts = '/select-debts',
  FinalizeAdditionalFunds = '/finalize-additional-funds',
  FinalizeReviewOffer = '/finalize-review-offer',

  EmailNotificationAlert = '/email-alert',

  OfferStatus = '/offer-status',

  UnfreezeCreditScore = '/unfreeze-credit-score',

  BureauVerification = '/bureau-verification',

  ExtendedIdentityCheck = '/extended-identity-check',
  ExtendedIdentityAddresses = '/extended-identity-addresses',

  Feedback = '/feedback',
  FundsSent = '/funds-sent',

  Error = '/error',
  Logout = '/logout',
  // Verify SMS to relogin
  SmsLogin = '/smsLogin',

  // Financial Checkup
  YourPhoneNumber = '/your-phone-number',
  VerifyPhoneNumber = '/verify-phone-number',
  YourEmail = '/your-email',
  VerifyEmail = '/verify-email',
  YourIncome = '/your-income',
  MethodAuth = '/auth',
  Analyzing = '/analyzing',
  AnalyzingUpdatedOffer = '/analyzing-updated-offer',
  YourBirthDate = '/your-birth-date',
  YourAddress = '/your-address',
  YourSSN4 = '/your-short-ssn',
  YourEmployer = '/your-employer',
  AdditionalIncome = '/additional-income',

  // Financial Dashboard
  FinancialDashboard = '/financial-dashboard',
  YourLoans = '/your-loans',
  ManageYourLoan = '/manage-your-loan/:loanId',
  LoansHistory = '/loans-history',

  CardApplied = '/card-applied',
  AdditionalFunds = '/additional-funds',

  // Card
  CardApplicationSuccessful = '/card-application-successful',
  BuildCreditAvoidDebtSaveMoney = '/build-credit-avoid-debt-save-money',
  ReferralProgram = '/referral-program',
  XSellLoader = '/xsell-loader',
  ErrorConsolidating = '/error-consolidating',
  ConnectPaycheck = '/connect-paycheck',
  ConnectPaycheckFeedback = '/connect-paycheck-feedback',
  CardRewards = '/card-rewards',
  SmartSpending = '/smart-spending',
  SmartAutoPay = '/smart-auto-pay',
  ImportDebt = '/import-debt',
  CardSummary = '/card-summary',
  ApplyEmployeeLoan = '/apply-employee-loan',
  ConfirmYourDetails = '/confirm-your-details',
  ConfirmReapplyDetails = '/confirm-reapply-details',
  StayInTouch = '/stay-in-touch',

  // Not being used
  Location = '/location',
  LoanAmountRange = '/loan-amount',
  CreditScoreRange = '/credit-score',

  // Open DDA
  OpenDDADone = '/open-dda-done',

  // Missed Payments
  MissedPayment = '/missed-payment',
  MakeAPayment = '/make-a-payment',
  MissedPaymentReason = '/missed-payment-reason',
  Plaid = '/employment-verify',
  PlaidCheckingAccounts = '/checking-accounts',
  BankAccount = '/bank-account',
  Authorization = '/authorization',
  WaitingAuthorization = '/waiting-authorization',
  MakingPayment = '/making-payment',
  PaymentInitiated = '/payment-initiated',
  PaymentFailed = '/payment-failed',

  // Student Loan
  StudentLoanEmployer = '/student-loan-employer',
  StudentLoanWork = '/student-loan-work',
  StudentLoanHousehold = '/student-loan-household',
  StudentLoanIncome = '/student-loan-income',
  StudentLoanEstimate = '/student-loan-estimate',
  StudentLoanUploadAidData = '/student-loan-upload-aid-data',
  StudentLoanPlan = '/student-loan-plan',
  StudentLoanSteps = '/student-loan-steps',
  StudentLoanExploreMore = '/student-loan-explore-more',
  StudentLoanLater = '/student-loan-later',
  StudentLoanBlocked = '/student-loan-blocked',
  StudentLoanNotEligible = '/student-loan-not-eligible',
  StudentLoanApplyStepsIntro = '/student-loan-apply-steps-intro',
  StudentLoanApplySteps = '/student-loan-apply-steps',
  StudentLoanApplyStepsCompleted = '/student-loan-apply-steps-completed',
  StudentLoanServiceAgreementDone = '/sl-service-agreement-done',

  MethodPayment = '/method-payments/:id',
  AvailableShifts = '/shifts',
  ShiftDetails = '/shifts/:id',
  LoanPayment = '/loan-payments/:id',

  // AICoach
  AICoachGoals = '/goals',
  AICoachMonthlySavings = '/monthly-savings',
}

export const STUDENT_LOAN_ROUTE_PREFIX = '/student-loan';
